/**
 * PublicRoute — for /login, /signup, /register.
 *
 * If the visitor is already authenticated, send them to the dashboard
 * instead of showing a sign-in page they don't need.
 */
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useTeacher } from "../api/queries/teacher";
import LoadingScreen from "./LoadingScreen";

export default function PublicRoute({ children }: { children: ReactNode }) {
  const { data: teacher, isLoading } = useTeacher();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (teacher) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
